import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';
import { DelphireApiService } from '../services/delphire-api.service';
import { FirebaseService } from '../services/firebase.service';
import { LocalStorageService } from '../services/local-storage-service.service';
import { SurveyQuestion, SurveyTemplate } from './survey-template';
import { UserSurveyData } from './user-survey-data';


@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit {

  displaySurvey: boolean = false

  submitted: boolean = false
  
  MainSurveyTemplate: SurveyTemplate | null = null

  UserSurveyData: UserSurveyData | null = null

  numCompletedCourses: number = 0

  selectedResponses: number[] = []

  registrationData: any[] = []

  lastTimeReloaded: number = moment().seconds()

  constructor(
    private localStorage: LocalStorageService,
    private delphireApi: DelphireApiService,
    private firebaseService: FirebaseService,
    private router: Router,
    private spinner: SpinnerVisibilityService,
  ) {

    this.router.events.subscribe((event) => {
      let now = moment()
      if ((now.seconds() - this.lastTimeReloaded) > 5) {
        console.log('%c In survey - route change detected; reloading reloading', 'color:cyan')
        this.lastTimeReloaded = now.seconds()
        this.checkIfSurveyShouldDisplay()
      }
    })
  }


  ngOnInit(): void {
    
    this.spinner.hide()
    
    this.loadAllDataOnceCurrentSpaceIsSet()

  }


  loadAllDataOnceCurrentSpaceIsSet(): void {

    let currentSpace = this.localStorage.get('currentSpace')
    if (currentSpace == null) {
      setTimeout(() => {
        this.loadAllDataOnceCurrentSpaceIsSet()
      }, 300)
    } else {
      this.loadAllData()
    }
  }


  async loadAllData(): Promise<void> {

    await this.loadSurveyFromData()

    console.log('%cFinished loading survey template data:', 'color:orange')
    console.log(this.MainSurveyTemplate)

    // Nothing to do if we don't have a survey template set
    if (this.MainSurveyTemplate == null) {
      return
    }

    if (!this.MainSurveyTemplate.enabled) {
      console.log('%cSurvey is not enabled', 'color:red')
      return
    }

    this.initiateSelectedResponses()

    if (this.MainSurveyTemplate.startType === 'onDate') {
      if (!this.MainSurveyTemplate.startDate || this.MainSurveyTemplate.startDate == "") {
        console.log('%cWarning: survey set to start on date but no start date set', 'color:red')
        return
      }
      let surveyStartDate = moment(this.MainSurveyTemplate.startDate)
      let now = moment()
      let minutesSinceSurveyStart = now.diff(surveyStartDate, 'minutes')
      console.log('%cMINUTES SINCE SURVEY START: ' + minutesSinceSurveyStart, 'color:red')
      if (minutesSinceSurveyStart < 0) {
        return
      }
    }

    await this.checkIfSurveyShouldDisplay()

    // if (this.MainSurveyTemplate.frequency === 'everyNumberOfDays' && this.MainSurveyTemplate.frequencyNumberOfDays > 0) {
    //   await this.numberOfDays()
    // } else if (this.MainSurveyTemplate.frequency === 'everyNumberOfCourses' && this.MainSurveyTemplate.frequencyNumberOfCourses > 0) {
      
    // }

  }


  async checkIfSurveyShouldDisplay(): Promise<void> {

    if (this.MainSurveyTemplate === null) {
      return
    }

    if (!this.MainSurveyTemplate.enabled) {
      return
    }

    // don't go through trouble if we're already displaying
    if (this.displaySurvey) {
      // this.doShouldShowSurveyLogicCheck()
      return
    }

    await this.getUserCourseCompletionData()

    console.log('%cSurvey - retrieved course completion data, continuing', 'color:orange')
    
    this.countUserCourseCompletionToDetermineIfShouldDisplaySurve()

    const { user } = this.localStorage.get('delphireUser')

    if (user != null) {
      this.getSurveyDataForUserToDetermineIfShouldDisplaySurvey()
    }
    
  }


  async getUserCourseCompletionData(): Promise<void> {

    const { user } = this.localStorage.get('delphireUser')

    let currentSpace = this.localStorage.get('currentSpace')
    let tenantId: any = null
    if (currentSpace != null) {
      tenantId = this.localStorage.get('currentSpace').id
    }

    if (!tenantId) {
      return
    }

    console.log('%cDoing data check for survey with tenant ID ' + tenantId + ' and user ID ' + user.id, 'color:cyan')

    return new Promise((resolve, reject) => {
      this.delphireApi
        .postRequestPrisma('/iam/registrations',{tenantId, learnerId: user.id})
          .then((res)=>{
            res.subscribe((data)=>{
              console.log('%cSURVEY CHECK - COURSE REGISTRATION DATA: ', 'color:#00FF00')
              console.log(data)
  
              if (data.body.registrations == null || data.body.registrations.length <= 0) {
                // console.log('%cMISSING COURSE REGISTRATION INFO: ' + courseId, 'color:red')
                reject();
                return;
              }
              
              this.registrationData = data.body.registrations
  
              resolve();
            })
          })
    });
  }


  async loadSurveyFromData(): Promise<any> {
    // let TheSurveyTemplate: SurveyTemplate = {
    //   name: 'Test Survey',
    //   description: 'This is a test survey',
    //   required: false,
    //   frequencyNumberOfCourses: 3,
    //   frequencyNumberOfDays: 0,
    //   startDate: new Date('2025-09-15'),
    //   questions: [
    //     { text: 'Who is your daddy and what does he do?' },
    //     { text: 'What is your name?' },
    //     { text: 'What is your quest?' },
    //     { text: 'What is the capital of Assyria?' },
    //   ]
    // }

    // this.MainSurveyTemplate = TheSurveyTemplate;

    let currentSpace = this.localStorage.get('currentSpace')
    if (currentSpace == null) {
      return
    }

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let TheSurveyComponent: SurveyComponent = this

    return new Promise((resolve, reject) => {
      const { databaseUrl } = currentSpace
      const path: string = `${environment.firebasePaths.space}surveys/`
      this.firebaseService
        .db(databaseUrl)
        .object(path)
        .subscribe(
          (returnedSurveyData: any) => {

            // console.log('%cRetrieved survey template data:', 'color: #00FF00', returnedSurveyData)
            let now = moment()
            
            if (returnedSurveyData) {

              // console.log(Object.getOwnPropertyNames(returnedSurveyData));

              let surveyTemplateIds = Object.getOwnPropertyNames(returnedSurveyData);
              let surveyTemplate = returnedSurveyData[surveyTemplateIds[0]];

              console.log('%cSurvey template data here', 'color:#00FF00')
              console.log(surveyTemplate)

              if (!surveyTemplate.questions) {
                console.log('%cWARNING - found survey template data with no questions!', 'color:red')
                resolve(false)
                return
              }

              let questionIds = Object.getOwnPropertyNames(surveyTemplate.questions);

              if (questionIds.length <= 0) {
                console.log('%cWARNING - found survey template data with no questions!', 'color:red')
                resolve(false)
                return
              }

              let questionsArray = []
              for (let i = 0; i < questionIds.length; i++) {
                let questionData = surveyTemplate.questions[questionIds[i]]
                questionsArray.push(questionData)
              }

              questionsArray = questionsArray.sort((question1, question2) => question1.order - question2.order)

              surveyTemplate.questions = questionsArray

              if (surveyTemplate.frequencyNumberOfDays) {
                surveyTemplate.frequencyNumberOfDays = Number(surveyTemplate.frequencyNumberOfDays)
              }

              if (surveyTemplate.frequencyNumberOfCourses) {
                surveyTemplate.frequencyNumberOfCourses = Number(surveyTemplate.frequencyNumberOfCourses)
              }

              TheSurveyComponent.MainSurveyTemplate = surveyTemplate

            } else {

              console.log('%cNo survey template data found', 'color:orange')
            }
            
            resolve(true)
          },
          (error: any) => {
            reject(error)
          }
        )
    })
  }


  initiateSelectedResponses(): void {
    if (!this.MainSurveyTemplate) {
      return;
    }

    this.selectedResponses = [];

    for (let i = 0; i < this.MainSurveyTemplate.questions.length; i++) {
      this.MainSurveyTemplate.questions[i].index = i
      this.selectedResponses.push(-1)
    }

    console.log('%cSelected responses initialized:', 'color:yellow')
    console.log(this.selectedResponses)
  }


  onClickResponse(score: number, TheSurveyQuestion: SurveyQuestion): void {
    let index = TheSurveyQuestion.index!
    this.selectedResponses[index] = score

    console.log('%cCURRENT RESPONSES:', 'color:cyan')
    console.log(this.selectedResponses)
  }


  isResponseSelected(index: number, score: number): boolean {
    if (this.selectedResponses[index] === score) {
      return true
    }

    return false;
  }


  canSubmit(): boolean {
    let responsesWithNoScore = this.selectedResponses.filter(theValue => theValue === -1)
    return (responsesWithNoScore.length <= 0)
  }


  submit(): void {
    console.log('%cSUBMIT', 'color:#00FF00');
    this.saveSurveyData();
    this.saveGeneralSurveyData()

    this.submitted = true

    this.saveClosedSurveyData()
  }


  closeAfterSubmit(): void {
    // already did closing logic so dont wanna do it again
    this.displaySurvey = false
  }


  close(): void {
    this.saveClosedSurveyData()
    this.displaySurvey = false
  }


  async saveSurveyData() {
    console.log('%cSAVING RESPONSES', 'color:yellow');
    const { user } = this.localStorage.get('delphireUser')

    const args = {
      userId: user.id,
      namespace: 'Survey/responses',
      key: uuidv4(),
      value: {
        surveyId: this.MainSurveyTemplate?.id,
        surveyName: this.MainSurveyTemplate?.name,
        createdAt: moment().toISOString(),
        responses: this.getSurveyResponsesForSaving(),
        numberOfCoursesCompleteAtTimeOfSurvey: this.numCompletedCourses
      }
    }
    return new Promise((resolve, reject) => {
      this.delphireApi
        .postRequest('userData/updateItem', args)
        .then((response) => {
          response.subscribe((response) => {
            console.log('%cSAVED SURVEY DATA', 'color:#00FF00')
            console.log(response)
          })
        })
    })
  }


  async saveGeneralSurveyData() {
    console.log('%cSAVING GENERAL SURVEY DATA', 'color:yellow');
    const { user } = this.localStorage.get('delphireUser')

    const args = {
      userId: user.id,
      namespace: 'Survey',
      key: 'general',
      value: {
        lastTimeAnsweredSurvey: moment().toISOString(),
        numberOfCoursesCompleteLastTimeSurveyed: this.numCompletedCourses
      }
    }
    return new Promise((resolve, reject) => {
      this.delphireApi
        .postRequest('userData/updateItem', args)
        .then((response) => {
          response.subscribe((response) => {
            console.log('%cSAVED SURVEY DATA', 'color:#00FF00')
            console.log(response)
          })
        })
    })
  }


  async saveClosedSurveyData() {
    console.log('%cSAVING CLOSED SURVEY DATA', 'color:yellow');
    const { user } = this.localStorage.get('delphireUser')

    const args = {
      userId: user.id,
      namespace: 'Survey',
      key: 'closed',
      value: {
        lastClosedSurveyId: this.MainSurveyTemplate?.id,
        lastTimeClosed: moment().toISOString(),
        numberOfCoursesCompleteLastTimeClosed: this.numCompletedCourses,
      }
    }
    return new Promise((resolve, reject) => {
      this.delphireApi
        .postRequest('userData/updateItem', args)
        .then((response) => {
          response.subscribe((response) => {
            console.log('%cSAVED CLOSED DATA', 'color:#00FF00')
            console.log(response)
          })
        })
    })
  }


  getSurveyResponsesForSaving(): any[] {

    let responses = []
    for (let i = 0; i < this.selectedResponses.length; i++) {
      console.log('%cWTF', 'color:red')
      console.log(this.MainSurveyTemplate?.questions[i])
      let oneResponse = {
        questionText: this.MainSurveyTemplate?.questions[i].text,
        response: this.selectedResponses[i]
      }

      responses.push(oneResponse)
    }

    return responses
  }


  countUserCourseCompletionToDetermineIfShouldDisplaySurve(): void {
    if (this.registrationData.length <= 0) {
      return
    }

    let numCompletedCourses = 0

    let completedRegistrationData = this.registrationData
      .filter((theRegData: any) => theRegData.activityDetails.activityCompletion === 'COMPLETED')
    
    if (this.MainSurveyTemplate!.specificCourses && this.MainSurveyTemplate!.specificCourses.length > 0) {

      let surveyTemplateSpecificCourseIds = 
        this.MainSurveyTemplate!.specificCourses.map((theSpecificCourse) => theSpecificCourse.id)

      console.log('%cCHECKING USER COURSE DATA FOR SPECIFIC COURSES', 'color:cyan')
      console.log(this.MainSurveyTemplate?.specificCourses)
      
      // Further filter our completed course list if we only want to count specific courses
      completedRegistrationData = completedRegistrationData
        .filter((theRegData: any) => surveyTemplateSpecificCourseIds.includes(theRegData.course.id))

      numCompletedCourses = completedRegistrationData.length

    } else {
      numCompletedCourses = completedRegistrationData.length
    }

    this.numCompletedCourses = numCompletedCourses

    // For testing
    // this.numCompletedCourses = 4

    console.log('%c# OF COMPLETED COURSES: ' + this.numCompletedCourses, 'color:#00FF00')

    // console.log('%cCURRENT USER', 'color:red')
    // console.log(user)
  }


  async getSurveyDataForUserToDetermineIfShouldDisplaySurvey(): Promise<any> {

    const { user } = this.localStorage.get('delphireUser')
    let currentSpace = this.localStorage.get('currentSpace')
    if (currentSpace == null) {
      return
    }

    return new Promise((resolve, reject) => {
      const { databaseUrl } = currentSpace
      const path: string = `${environment.firebasePaths.space}userData/${user.id}/Survey`
      this.firebaseService
        .db(databaseUrl)
        .object(path)
        // .pipe(first()) //! this makes it only pull ONCE instead of being live
        .subscribe(
          (surveyData: any) => {

            if (this.MainSurveyTemplate == null) {
              return
            }

            let now = moment()
            let lastTimeClosedDays = null
            
            this.UserSurveyData = surveyData

            console.log('%cUser survey data:', 'color: #00FF00', this.UserSurveyData)

            if (this.UserSurveyData && this.UserSurveyData.closed) {

              let lastTimeClosed = moment(this.UserSurveyData.closed.lastTimeClosed)
              lastTimeClosedDays = now.diff(lastTimeClosed, 'days')
            }
            
            // This is a survey we've responded to before
            if (
              this.UserSurveyData && this.UserSurveyData.general &&
              this.UserSurveyData.closed.lastClosedSurveyId === this.MainSurveyTemplate.id
            ) {

              let lastTimeSurveyed = moment(this.UserSurveyData.general.lastTimeAnsweredSurvey)
              let lastTimeSurveyedDays = now.diff(lastTimeSurveyed, 'days')
              let lastTimeSurveyedMinutes = now.diff(lastTimeSurveyed, 'minutes')

              let numberOfCoursesCompletedLastTimeToUse = Number(this.UserSurveyData.general.numberOfCoursesCompleteLastTimeSurveyed)
              if (this.UserSurveyData.closed && this.UserSurveyData.closed.numberOfCoursesCompleteLastTimeClosed > numberOfCoursesCompletedLastTimeToUse) {
                numberOfCoursesCompletedLastTimeToUse = this.UserSurveyData.closed.numberOfCoursesCompleteLastTimeClosed
              }

              console.log('%cSurvey time difference', 'color:cyan')
              console.log('%c' + lastTimeSurveyedDays + ' days', 'color:cyan')
              console.log('%c' + lastTimeSurveyedMinutes + ' minutes', 'color:cyan')
              console.log('%c' + numberOfCoursesCompletedLastTimeToUse + ' # courses complete', 'color:cyan')

              // If the survey is not required, count last days using the last time the survey was closed
              let lastTimeDaysToUse = lastTimeSurveyedDays
              if (!this.MainSurveyTemplate.required && lastTimeClosedDays != null) {
                if (lastTimeClosedDays <= lastTimeSurveyedDays) {
                  lastTimeDaysToUse = lastTimeClosedDays
                }
              }

              if (this.MainSurveyTemplate.frequency === 'everyNumberOfCourses' && this.MainSurveyTemplate.frequencyNumberOfCourses > 0) {

                if (
                  (this.numCompletedCourses - numberOfCoursesCompletedLastTimeToUse) >= 
                  this.MainSurveyTemplate.frequencyNumberOfCourses
                ) {
                  this.displaySurvey = true
                }

              } else if (this.MainSurveyTemplate.frequency === 'everyNumberOfDays' && this.MainSurveyTemplate.frequencyNumberOfDays > 0) {

                if (lastTimeDaysToUse >= this.MainSurveyTemplate.frequencyNumberOfDays) {
                  this.displaySurvey = true
                }

              }

            } else { // No submitted survey data yet / or we're on a new survey

              console.log('%cNo submitted survey data / or new survey found', 'color:orange')

              // User has never done or seen survey before - show
              if (!this.UserSurveyData) {

                this.displaySurvey = true

              // If we already saw a survey before, but this is a new one, show it regadless of what other rules are
              } else if (
                this.UserSurveyData &&
                this.UserSurveyData.closed && 
                this.UserSurveyData.closed.lastClosedSurveyId != this.MainSurveyTemplate.id
              ) {
                this.displaySurvey = true
              
              } else if (this.MainSurveyTemplate.frequency === 'everyNumberOfDays' && this.MainSurveyTemplate.frequencyNumberOfDays > 0) {

                // No submitted survey data yet, but the user has seen the survey before
                if (this.UserSurveyData && this.UserSurveyData.closed) {

                  if (lastTimeClosedDays && lastTimeClosedDays >= this.MainSurveyTemplate.frequencyNumberOfDays) {
                    this.displaySurvey = true
                  }
                } else {
                  this.displaySurvey = true
                }

              } else if (this.MainSurveyTemplate.frequency === 'everyNumberOfCourses') {

                let numberOfCoursesCompletedLastTimeToUse = 0

                if (this.UserSurveyData && this.UserSurveyData.closed) {
                  numberOfCoursesCompletedLastTimeToUse = this.UserSurveyData.closed.numberOfCoursesCompleteLastTimeClosed
                }

                if (this.MainSurveyTemplate.frequencyNumberOfCourses > 0) {
                  if (
                    (this.numCompletedCourses - numberOfCoursesCompletedLastTimeToUse) >= 
                    this.MainSurveyTemplate.frequencyNumberOfCourses
                  ) {
                    this.displaySurvey = true
                  }
                }
              }

            }

            // this.doShouldShowSurveyLogicCheck()

            resolve(true)
          },
          (error: any) => {
            reject(error)
          }
        )
    })
  }

}
